
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: ['text'],
  setup() {},
})
